import React, { ElementType } from 'react';
import styled, { Interpolation, ThemedStyledProps, css } from 'styled-components';
import { Link } from 'react-router-dom';

import { CallToAction, CallToActionProps } from '../styling/styles';

export type DynamicCallToActionProps = {
  styles: Interpolation<ThemedStyledProps<CallToActionProps, any>>;
  to?: string;
  href?: string;
  target?: string;
  onClick?: Function;
};

const DynamicCallToAction: React.FC<DynamicCallToActionProps> = (props) => {
  let CTA: ElementType = styled.div``;
  const { styles, ...ctaProps } = props;

  const classStyle = css`
    ${CallToAction}
    ${styles}
  `;

  if (props.to) {
    CTA = styled(Link)`
      ${classStyle}
    `;
  } else if (props.href) {
    CTA = styled.a`
      ${classStyle}
    `;
  } else if (props.onClick) {
    CTA = styled.button`
      ${classStyle}
    `;
  }

  return <CTA {...ctaProps} />;
};

export default DynamicCallToAction;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DynamicCallToAction.tsx